import { Icons } from "../components/Icons/Icons";

export const jobsPageMainData = {
    title: "Stellenangebote",
    description:
      "",
    info:[
        {
            description:"Kfz-Mechaniker (m/w/x)",
            link:"jobs/mechaniker"
        },
        {
       
            description:"Aushilfe Werkstatt (m/w/x)",
                 link:"jobs/aushilfe-werkstatt"
        },
        {
            description:"Aushilfe Büro (m/w/x)",
           link:"jobs/aushilfe-buero"
        },
    ]
    };
  
  
  export const jobsPageSecondData = {
    title: "Standort",
    src:"./assets/images/location/location.png",
  };

  export const jobsPageKontaktFormData = {
    ready:"Bald verfügbar!",
    title: "Kontaktformular",
    name:"Name*",
    email:"E-Mail Adresse*",
    msg:"Ihre Nachricht*",
    tip:"Mit dem Klick auf den Button 'Absenden' stimme ich zu, dass meine Angaben und Daten zur Beantwortung meiner Anfrage elektronisch erhoben und gespeichert werden.",
    btn:"Absenden"
  };